module.exports = __webpack_public_path__ + "static/heroslide-6-94f2cb7a2c50a53d2515ceccb8a47000.jpeg";